import { Component, Input, OnInit } from '@angular/core';
import { VersionUpdateService } from '@libs/common-services';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'portal-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
export class FooterComponent implements OnInit {
  @Input() isLogin = false;
  public date: Date = new Date();
  public clientVersion = environment.clientVersion;

  constructor(private versionUpdateService: VersionUpdateService) {}

  ngOnInit(): void {
    this.loadRuntimeVersion();
  }

  private async loadRuntimeVersion(): Promise<void> {
    this.clientVersion = await this.versionUpdateService.getCurrentVersion(
      environment.clientVersion
    );
  }
}
